import Api from "@/components/Api";
import { getInstance } from "@/app";
import svg from "../../assets/svg/trees.svg";

import "./style.css";

export default class OurPropertiesList {
  static selector = ".op-list";

  constructor(block) {
    this.block = block;

    this.featured = this.block.querySelector(".property-preview--featured");
    this.list = this.block.querySelector(".op-list__list");
    this.pageSize = this.list.childElementCount;
    this.showMoreButton = this.block.querySelector(".op-list__show-more");
    this.maxCount = parseInt(this.block.dataset.count, 10);
  }

  handleShowMoreClick = async () => {
    this.showMoreButton.classList.add("op-list__show-more--loading");
    this.showMoreButton.disabled = true;

    const paramsArray = window.location.search
      .substring(1)
      .split("&")
      .map((item) => {
        const obj = {};
        const splittedItem = item.split("=");
        if (!splittedItem[1]) {
          return obj;
        }
        obj[`${splittedItem[0]}`] = splittedItem[1];
        return obj;
      });

    let params = {};

    paramsArray.forEach((param) => {
      params = { ...params, ...param };
    });

    try {
      const properties = await Api.getProperties({
        page: this.page + 1,
        size: this.pageSize,
        exclude: this.featured ? [this.featured.dataset.id] : [],
        range_min: params["range_min"] || 0,
        range_max: params["range_max"] || 3000,
        order_by: params["order_by"],
        region: params["region"],
        land_use: params["land_use"],
        price: params["price"],
      });

      this.appendProperties(properties);

      if (this.map) {
        this.map.updateMap();
      }

      this.page += 1;
    } catch (error) {
      console.error("Error loading new posts", error);
    } finally {
      this.showMoreButton.disabled = false;
      this.showMoreButton.classList.remove("op-list__show-more--loading");
    }
  };

  appendProperties(properties) {
    properties.forEach((property) => {
      const finalProperty = document.createElement("div");
      finalProperty.classList.add("col-md-6");

      const opListItem = document.createElement("div");
      opListItem.classList.add("op-list__item");

      finalProperty.appendChild(opListItem);

      const {
        image,
        imageAlt,
        title,
        url,
        lat,
        lng,
        location,
        acreageHa,
        acreageAc,
        price,
        priceQualifier,
        just_added,
        tag,
        is_open_house_day,
      } = property;

      const propertyBox = document.createElement("article");
      propertyBox.classList.add("property-preview");

      // add dataset to property box
      propertyBox.dataset.lat = lat;
      propertyBox.dataset.lng = lng;
      propertyBox.dataset.title = title;
      propertyBox.dataset.image = image;
      propertyBox.dataset.location = location;
      propertyBox.dataset.link = url;

      const imageBox = document.createElement("div");
      imageBox.classList.add("property-preview__img-box");

      if (just_added) {
        const justAddedLabel = document.createElement("div");
        justAddedLabel.classList.add("property-preview__tag");
        justAddedLabel.innerText = "Just added";

        imageBox.appendChild(justAddedLabel);
      }

      if (tag) {
        const tagLabel = document.createElement("div");
        tagLabel.classList.add("property-preview__tag");

        if (tag.tag === "Under Offer") {
          tagLabel.classList.add("property-preview__tag--yellow");
        } else if (tag.tag === "Sold") {
          tagLabel.classList.add("property-preview__tag--red");
        }

        tagLabel.innerText = tag.tag;

        imageBox.appendChild(tagLabel);
      }

      if (is_open_house_day) {
        const closingDateRibbon = document.createElement("div");
        closingDateRibbon.classList.add(
          "property-preview__closing-date-ribbon"
        );
        closingDateRibbon.innerHTML = `<div class="property-preview__closing-date-ribbon-inner">Closing Date</div>`;
        imageBox.appendChild(closingDateRibbon);
      }

      const imageLink = document.createElement("a");
      imageLink.setAttribute("href", url);

      imageLink.appendChild(imageBox);
      propertyBox.appendChild(imageLink);

      if (image) {
        const imageItem = document.createElement("img");
        imageItem.classList.add("property-preview__img");
        imageItem.setAttribute("src", image);
        if (imageAlt) {
          imageItem.setAttribute("alt", imageAlt);
        }
        imageBox.appendChild(imageItem);
      } else {
        const placeholderBox = document.createElement("div");
        placeholderBox.classList.add("property-preview__img-placeholder");

        const placeholder = document.createElement("div");
        placeholder.classList.add("img-placeholder");

        const svgImg = document.createElement("img");
        svgImg.setAttribute("src", svg);

        placeholder.appendChild(svgImg);
        placeholderBox.appendChild(placeholder);

        imageBox.appendChild(placeholderBox);
      }

      if (title) {
        const anchor = document.createElement("a");
        anchor.classList.add("property-preview__link");
        anchor.setAttribute("href", url);

        const titleItem = document.createElement("h4");
        titleItem.innerText = title;
        titleItem.classList.add("property-preview__prop-title");

        anchor.appendChild(titleItem);

        propertyBox.appendChild(anchor);
      }

      if (location) {
        const locationItem = document.createElement("p");
        locationItem.classList.add("property-preview__prop-location");

        locationItem.innerText = location;
        propertyBox.appendChild(locationItem);
      }

      if (acreageHa || acreageAc) {
        const acreageBox = document.createElement("div");
        acreageBox.classList.add("property-preview__prop-acreage");

        let acreageValue = "";

        if (acreageHa) {
          acreageValue += `${acreageHa}ha`;
        }
        if (acreageHa && acreageAc) {
          acreageValue += " | ";
        }
        if (acreageAc) {
          acreageValue += `${acreageAc}ac`;
        }

        acreageBox.innerText = acreageValue;
        propertyBox.appendChild(acreageBox);
      }

      if (price) {
        const priceBox = document.createElement("div");
        priceBox.classList.add("property-preview__prop-price");

        const priceEl = document.createElement("span");
        priceEl.classList.add("property-preview__prop-price-value");
        priceEl.innerText = `£ ${parseFloat(price).toLocaleString("en")}`;

        priceBox.appendChild(priceEl);

        const priceLabel = document.createElement("span");
        priceLabel.classList.add("property-preview__prop-price-label");
        priceLabel.innerText = priceQualifier;

        priceBox.appendChild(priceLabel);
        propertyBox.appendChild(priceBox);
      }

      opListItem.appendChild(propertyBox);

      this.list.appendChild(finalProperty);
    });

    this.count = this.list.childElementCount;

    if (this.count >= this.maxCount) {
      this.showMoreButton.classList.add("op-list__show-more--done");
    }

    if (this.count < this.maxCount) {
      this.showMoreButton.classList.add("op-list__show-more--ready");
    }
  }

  onReady = () => {
    this.page = 1;
    this.count = this.list.childElementCount;

    if (this.showMoreButton) {
      this.showMoreButton.addEventListener("click", this.handleShowMoreClick);

      if (this.count >= this.maxCount) {
        this.showMoreButton.classList.add("op-list__show-more--done");
      }

      if (this.count < this.maxCount) {
        this.showMoreButton.classList.add("op-list__show-more--ready");
      }
    }
  };

  onComplete = () => {
    this.map = getInstance(document.getElementById("map"));
  };
}
